import { captureException } from "@sentry/browser";
import type { LoaderFunction } from "react-router-dom";
import type { FetchReportResult } from "../api/reportFetcher";
import { fetchReport } from "./FetchReport";

export type ReportLoaderResult = FetchReportResult;

async function doFetchReport(token: string) {
  try {
    return await fetchReport(token);
  } catch (error) {
    console.error(error);
    captureException(error);
    // The error is handled in the component, so we should rethrow it to trigger the error boundary
    // The same would happen if we just returned null, since the component expects a contract to be returned, but rethrowing makes it more explicit that an error occurred
    throw error;
  }
}

export const reportLoader: LoaderFunction = async ({ request }) => {
  if (typeof window === "undefined") return null;
  const token = new URL(request.url).searchParams.get("token");
  if (!token) return null;

  return { report: doFetchReport(token) };
};
reportLoader.hydrate = false;
